import { CustomPointOfService } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { BASE_STORE_SHOPS } from '../city-state';

export const LOAD_BASE_STORE_SHOPS = '[City] Base Store Shops Load';
export const LOAD_BASE_STORE_SHOPS_SUCCESS = '[City] Base Store Shops Load Success';
export const LOAD_BASE_STORE_SHOPS_FAIL = '[City] Base Store Shops Load Fail';

export class LoadBaseStoreShops extends StateUtils.EntityLoadAction {
  readonly type = LOAD_BASE_STORE_SHOPS;

  constructor(public code: string) {
    super(BASE_STORE_SHOPS, code);
  }
}

export class LoadBaseStoreShopsSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_BASE_STORE_SHOPS_SUCCESS;

  constructor(
    public code: string,
    public payload: CustomPointOfService[],
  ) {
    super(BASE_STORE_SHOPS, code, payload);
  }
}

export class LoadBaseStoreShopsFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_BASE_STORE_SHOPS_FAIL;

  constructor(
    public code: string,
    public payload: unknown,
  ) {
    super(BASE_STORE_SHOPS, code, payload);
  }
}

export type BaseStoreShopsAction = LoadBaseStoreShops | LoadBaseStoreShopsSuccess | LoadBaseStoreShopsFail;
